// Hotel lobby at night: two lamp blooms breathing out of phase, with slow
// motes drifting through the light.
const LAMPS = [
  { x: 22, y: 62, size: 68, delay: 0, dur: 9.5, opacity: 0.5 },
  { x: 74, y: 38, size: 52, delay: 3.2, dur: 11.5, opacity: 0.36 },
];

const MOTES = [
  { x: 12, y: 30, r: 0.9, delay: 0, dur: 12.5, opacity: 0.45 },
  { x: 26, y: 22, r: 0.6, delay: 3.4, dur: 15.0, opacity: 0.3 },
  { x: 38, y: 34, r: 1.1, delay: 1.6, dur: 13.4, opacity: 0.38 },
  { x: 49, y: 18, r: 0.7, delay: 5.1, dur: 16.2, opacity: 0.26 },
  { x: 60, y: 30, r: 0.9, delay: 2.3, dur: 14.1, opacity: 0.34 },
  { x: 71, y: 24, r: 0.6, delay: 6.2, dur: 12.8, opacity: 0.28 },
  { x: 82, y: 33, r: 1.0, delay: 4.0, dur: 15.6, opacity: 0.32 },
  { x: 92, y: 20, r: 0.7, delay: 1.1, dur: 13.9, opacity: 0.24 },
];

export default function AmbianceHotelLoungeAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--lounge"
      aria-hidden="true"
    >
      {LAMPS.map((lamp, index) => (
        <span
          key={`lamp-${index}`}
          className="mode-tile__lounge-lamp"
          style={{
            left: `${lamp.x}%`,
            top: `${lamp.y}%`,
            width: `${lamp.size}px`,
            height: `${lamp.size}px`,
            "--lamp-peak": lamp.opacity,
            animationDelay: `-${lamp.delay}s`,
            animationDuration: `${lamp.dur}s`,
          }}
        />
      ))}
      <svg
        className="mode-tile__lounge-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {MOTES.map((mote, index) => (
          <circle
            key={`mote-${index}`}
            className="mode-tile__lounge-mote"
            cx={mote.x}
            cy={mote.y}
            r={mote.r}
            style={{
              opacity: mote.opacity,
              animationDelay: `-${mote.delay}s`,
              animationDuration: `${mote.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
